import Oidc from "oidc-client";
import "babel-polyfill";

var mgr = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore({ store: window.sessionStorage }),
  authority: process.env.VUE_APP_SSO_URL + "/IdPOAuth2/ssogf256oidc",
  client_id: process.env.VUE_APP_SSO_CLIENT_ID,
  redirect_uri: window.location.origin + "/static/callback.html",
  response_type: "id_token token",
  scope: "openid profile email roleLEA rolelea",
  post_logout_redirect_uri: window.location.origin,
  silent_redirect_uri: window.location.origin + "/static/silent-renew.html",
  end_session_endpoint: process.env.VUE_APP_SSO_URL + "/auth/logout.jsp",
  userinfo_endpoint: process.env.VUE_APP_SSO_URL + "/IdPOAuth2/userinfo/ssogf256oidc",
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  metadata: {
      issuer: process.env.VUE_APP_SSO_URL + "/idp",
      authorization_endpoint: process.env.VUE_APP_SSO_URL + "/IdPOAuth2/authorize/ssogf256oidc",
      
    
      end_session_endpoint: process.env.VUE_APP_SSO_URL + "/auth/logout.jsp",
      jwks_uri: process.env.VUE_APP_SSO_URL + "/IdPOAuth2/jwk/ssogf256oidc",
      post_logout_redirect_uri: window.location.origin,

  }
});


Oidc.Log.logger = console;

// TODO: Gérer niveau de log en fonction de l'env
Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function (user) {
  //console.log("New User Loaded：", arguments);
  //console.log("Acess_token: ", user.access_token);
  console.log("Expires in: ", user.expires_in);

});

mgr.events.addAccessTokenExpiring(function () {
  //console.log("AccessToken Expiring：", arguments);
});

mgr.events.addAccessTokenExpired(function () {
  //console.log("AccessToken Expired：", arguments);
  alert("Votre session a expiré. Veuillez vous reconnecter.");
  mgr
    .signoutRedirect()
    .then(function (resp) {
      console.log("signed out", resp);
    })
    .catch(function (err) {
      console.log(err);
    });
});

mgr.events.addSilentRenewError(function () {
  console.error("Silent Renew Error：", arguments);
});

mgr.events.addUserSignedOut(function () {
  alert("Going out!");
  //console.log("UserSignedOut：", arguments);
  mgr
    .signoutRedirect()
    .then(function (resp) {
      console.log("signed out", resp);
    })
    .catch(function (err) {
      console.log(err);
    });
});

export default class SecurityService {
  // Renew the token manually
  renewToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .signinSilent()
        .then(function (user) {
          if (user == null) {
            self.signIn(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  getUser() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {

            return resolve(user);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Check if there is any user logged in
  getSignedIn() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Redirect of the current window to the authorization endpoint.
  signIn() {
    mgr.signinRedirect().catch(function (err) {
      console.log(err);
    });
  }

  // Redirect of the current window to the end session endpoint
  signOut() {
    mgr
      .signoutRedirect()
      .then(function (resp) {
        this.$router.push("/");

        console.log("signed out", resp);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  // Get the profile of the user logged in
  getProfile() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the token id
  getIdToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.id_token);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the session state
  getSessionState() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.session_state);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the access token of the logged in user
  getAccessToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.access_token);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Takes the scopes of the logged in user
  getScopes() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.scopes);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user roles logged in
  getRole() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile.role);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }


    // Get the user roles logged in
  getRoleLea() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile.roleLEA);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }
}
